import type { NBranches } from '@app/types';

export namespace NChains {
  export type Chain = {
    chainBranches: NBranches.ModelBranchLite[] | null;
    countBranches: number;
    id: number;
    name: string;
    isDeleted: boolean;
  } | null;

  export type ModelChain = {
    Id: number;
    Name: string | null;
    CountBranches: number;
    IsDeleted: boolean;
    MigrateId: number | null;
    ChainBranches: NBranches.ModelBranchLite[] | null;
  };

  export type ChainBranchesServerFormat = {
    BranchId: number;
    Name: string;
    IsSelected: boolean;
  };

  export type ChainBranches = {
    branchId: number;
    name: string;
    isSelected: boolean;
  };

  export type ModelChainsList = {
    Chains: ModelChain[] | null;
    CountActive: number;
    CountDeleted: number;
  };
}
